import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../constants/Endpoints/EndPoints";
import { FetchRequestHandler } from "../../../utils/commonUtilities";

export const fetchPracticeReviews = createAsyncThunk(
  "fetchPracticeReviews",
  async (practiceDisplayId) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/practices/${practiceDisplayId}/survey-reviews`
    );
    return result;
  }
);

export const fetchProviderslistitem = createAsyncThunk(
  "fetchProviderslistitem",
  async (practiceId) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/practices/${practiceId}/survey-reviews/provider`
    );
    return result;
  }
);

export const updatePracticeReviews = createAsyncThunk(
  "updatePracticeReviews",
  async ({ practiceId, data }) => {
    const result = await FetchRequestHandler(
      "put",
      `${baseUrl}api/practices/${practiceId}/survey-reviews`,
      data
    );
    return result;
  }
);

export const updateReviewList = createAsyncThunk(
  "updateReviewList",
  async ({ practiceId, providerId }) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/practices/${practiceId}/survey-reviews/provider/${providerId}`
    );
    return result;
  }
);
export const postReviewResponse = createAsyncThunk(
  "postReviewResponse",
  async ({ practiceId, caseNumber, payload }) => {
    const result = await FetchRequestHandler(
      "post",
      `${baseUrl}api/practices/${practiceId}/survey-reviews/${caseNumber}`,
      payload
    );
    return result;
  }
);

export const handleReviewResponseFormSubmit = createAsyncThunk(
  "handleReviewResponseFormSubmit",
  async ({ practiceId, providerId, caseNumber, payload }, thunkAPI) => {
    await thunkAPI.dispatch(
      postReviewResponse({
        practiceId,
        caseNumber,
        payload,
      })
    );

    /**
     *  Sometimes providerId won't present which means, user has selected `This Location` option in the dropdown which means reviews for entire providers.
     */
    if (providerId) {
      await thunkAPI.dispatch(updateReviewList({ practiceId, providerId }));
    } else {
      await thunkAPI.dispatch(fetchPracticeReviews(practiceId));
    }
  }
);
